var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationPin = function SvgLocationPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3347_11723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 9.1665C8.75 8.47615 9.30964 7.9165 10 7.9165H10.0083C10.6987 7.9165 11.2583 8.47615 11.2583 9.1665V9.17484C11.2583 9.86519 10.6987 10.4248 10.0083 10.4248H10C9.30964 10.4248 8.75 9.86519 8.75 9.17484V9.1665Z",
    fill: "#22C59E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9938 5.17263C11.7879 2.96676 8.2115 2.96676 6.00564 5.17263C3.79977 7.3785 3.79977 10.9549 6.00564 13.1608L9.99971 17.1549L13.9938 13.1608C16.1997 10.9549 16.1997 7.3785 13.9938 5.17263ZM4.82713 3.99412C7.68387 1.13738 12.3156 1.13738 15.1723 3.99412C18.029 6.85086 18.029 11.4826 15.1723 14.3393L10.589 18.9226C10.4327 19.0789 10.2207 19.1667 9.99971 19.1667C9.7787 19.1667 9.56674 19.0789 9.41046 18.9226L4.82713 14.3393C1.97039 11.4826 1.97038 6.85086 4.82713 3.99412Z",
    fill: "#22C59E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3347_11723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "location-pin.dec142fb0e725408b31320ff19bd853f.svg";